import { Card, CardContent } from '@/components/ui/card'
import { OrgStatus } from '@/models/user'

const COVERED = 'This customer is covered. Use the other tabs to change their fleet.'

const MESSAGES: Partial<Record<OrgStatus, string>> = {
  [OrgStatus.UNDERWRITING]: 'This customer has already chosen a quote.',
  [OrgStatus.ACTIVE]: COVERED,
}

/** For customers who aren't shopping; a covered customer renewing reads as covered too. */
export function ReadOnlyNotice({ status }: { status: OrgStatus }) {
  return (
    <Card>
      <CardContent>
        <p className="text-muted-foreground text-sm">{MESSAGES[status] ?? COVERED}</p>
      </CardContent>
    </Card>
  )
}
